import axios from 'axios';
import { io } from 'socket.io-client';

import { logoutUser } from '../store/userSlice';

  //const apiUrl='https://api.gsshopsolution.com:5000' //server conex str
  const apiUrl= process.env.REACT_APP_API_URL;
  const axiosInstance = axios.create({
    baseURL:apiUrl, // Set your default base URL here
    timeout: 10000, // Optional: Set a timeout for requests
    withCredentials: true, // Important: Enables sending cookies with requests
  });


axiosInstance.interceptors.request.use((config) => {
  const userString = sessionStorage.getItem('user');

  // Only proceed if `userString` exists
  if (userString) {
      const user = JSON.parse(userString);
      const method = config.method?.toLowerCase();

      // Modify the request based on the HTTP method
      if (['post', 'put', 'patch', 'delete'].includes(method)) {
          config.data = { ...config.data,
                             owner: user.owner._id,
                             user:user._id 
                          };  
      }

      if (method === 'get') {
          config.params = { ...config.data,
            owner: user.owner._id,
            user:user._id 
         }; 
      }
  }

  return config; // Always return the modified or original config
}, (error) => {
  // Handle any request errors
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;

      // Handle token expiration (401 Unauthorized or custom code)
      if (status === 401 || status === 403 ) {
        // Clear any existing token and user data
        sessionStorage.removeItem('token'); // Optional, in case it's being stored elsewhere
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('permissions');
        // Dispatch a logout action if you're using Redux
        logoutUser();
        // Redirect to login page
        setTimeout(()=>{
          window.location.href = '/'; // Redirect user to login page
        },2000)
        return Promise.reject('Session expired. Please log in again.');
      }
    }

    // Reject promise with error for other types of errors
    return Promise.reject(error);
  }
);

// Socket.IO instance
const socket = io(apiUrl, {
  transports: ['websocket'], // Use WebSocket for better performance
  autoConnect: true,        // Prevent automatic connection
  withCredentials: true,
});

export { axiosInstance, socket};

